import React from 'react';
import LoadingUpdates from '../generic-dashboards/loading/LoadingUpdates';
import { MissingData } from '../misc/MissingData';
import { replace_underscores_capitalize } from '../../helpers/string_formatters';
import InstitutionWhatsNew from './InstitutionWhatsNew';
import { recentUpdates } from '../../features/shared/interfaces/whats-new.interface';
import LiqExhibitTitleContainer from 'features/shared/UI/layout/LiqExhibitTitleContainer';
import { Button } from '@mui/material';

const UpdateTable = ({
    data,
    loading,
    name,
    setDisplayNetworkGraph,
}: {
    data: recentUpdates | null;
    loading: boolean;
    name: string;
    setDisplayNetworkGraph: (x: boolean) => void;
}) => {
    return (
        <div>
            <div className="flex md:flex-row flex-col justify-between gap-2 mb-2">
                <LiqExhibitTitleContainer
                    title={`${data?.month || ''} Updates for ${replace_underscores_capitalize(
                        name
                    )}`}
                    subtitle=""
                />
                {!loading && (
                    <Button
                        onClick={() => setDisplayNetworkGraph(true)}
                        style={{ textTransform: 'none', fontSize: '14px' }}
                        variant="outlined"
                    >
                        Lobbying Network for {replace_underscores_capitalize(name)}
                    </Button>
                )}
            </div>
            <hr className="h-0.5 my-3 bg-slate-100 rounded" />
            {loading ? (
                <LoadingUpdates />
            ) : !loading && !data ? (
                <MissingData />
            ) : data ? (
                <InstitutionWhatsNew data={data} name={name} />
            ) : (
                <></>
            )}
        </div>
    );
};

export default UpdateTable;
